import { useMemo } from 'react';

import { useTheme } from './ThemeContext';
import { THEMES } from './themes';
import { ThemeName } from './types';

// Lista de temas disponible para iterar
export const AVAILABLE_THEMES: ThemeName[] = Object.keys(THEMES) as ThemeName[];

export const useThemeSwitcher = () => {
  const { theme, setDynamicTheme, loading } = useTheme();

  const currentThemeName = useMemo<ThemeName>(() => {
    if (theme?.themeName && AVAILABLE_THEMES.includes(theme.themeName)) {
      return theme.themeName;
    }
    return 'FIELPET';
  }, [theme]);

  const switchToTheme = (themeName: ThemeName) => {
    const selectedTheme = THEMES[themeName];
    if (selectedTheme) {
      setDynamicTheme(selectedTheme);
    }
  };

  return {
    theme,
    loading,
    currentThemeName,
    availableThemes: AVAILABLE_THEMES,
    switchToTheme,
  };
};
